import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { gameLiveConnection, lobbyLiveConnection } from '../services';
import { RoutePaths } from '../enums/routes';
import { BET_SHOP_GAME_ID, TURBO_GAME_ID } from '../enums/constants';

class LiveConnection {
  handleSocketInit(pathname) {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    const { isSkipLobby } = gameConfigStore;
    const isTurbo = +gameId === TURBO_GAME_ID;
    const isBetShop = +gameId === BET_SHOP_GAME_ID;

    return new Promise((res) => {
      if (
        pathname === RoutePaths.game ||
        pathname === RoutePaths.turbo ||
        pathname === RoutePaths.betShop ||
        isSkipLobby
      ) {
        lobbyLiveConnection?.stop().then(() => {
          gameLiveConnection.init().then(() => {
            res({ socketPath: pathname });
          });
        });
      } else if (pathname === RoutePaths.lobby && !isTurbo && !isBetShop) {
        gameLiveConnection?.stop().then(() => {
          lobbyLiveConnection.init().then(() => {
            res({ socketPath: pathname });
          });
        });
      }
    });
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          res({ socketPath: window.location.pathname });
        });
      });
    });
  }

  connectionInitCallback({ socketPath }) {
    const initialInvokes = {
      [RoutePaths.lobby]: () => lobbyLiveConnection.sendLobbyGetInitialState(),
      [RoutePaths.game]: () => {
        gameLiveConnection.sendGameGetInitialState().then(() => {});
      },
      [RoutePaths.turbo]: () => {
        gameLiveConnection.sendGameGetInitialState().then(() => {});
      },
      [RoutePaths.betShop]: () => {
        gameLiveConnection.sendGameGetInitialState().then(() => {});
      },
    };
    if (initialInvokes[socketPath]) {
      initialInvokes[socketPath]();
    }
  }
}

export const liveConnection = new LiveConnection();
